import { MenuItem } from '@mui/material';
import { useCustomSnackbar } from 'components/NotificationSnackbars';
import { WorkspaceContext } from 'contexts/WorkspaceContext';
import { useContext, useState } from 'react';
import { NewWorkspaceTitle } from './NewWorkspaceTitle';
import { useCloneWorkspace } from './useCloneWorkspace';
import { useTranslation } from 'react-i18next';

export const CloneWorkspaceMenu = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('workspace');
  const { currentWorkspace: workspaceId } = useContext(WorkspaceContext);

  const [newType, setNewType] = useState<'system' | 'user'>();
  const { ready, save } = useCloneWorkspace({ workspaceId, newType: newType! });
  const { enqueueCustomSnackbar } = useCustomSnackbar();

  const onSave = (newTitle: string) => {
    save(newTitle)
      .then(() => {
        enqueueCustomSnackbar.success(t('cloneWorkspaceSuccess'));
      })
      .catch(() => {
        enqueueCustomSnackbar.error(t('cloneWorkspaceFail'));
      })
      .finally(onClose);
  };
  const onCancel = () => {
    setNewType(undefined);
  };

  return (
    <>
      <MenuItem
        onClick={() => {
          setNewType('user');
        }}
      >
        {t('cloneToPersonalWorkspace')}
      </MenuItem>
      {newType === 'user' && ready && <NewWorkspaceTitle onSave={onSave} onCancel={onCancel} />}
      <MenuItem
        onClick={() => {
          setNewType('system');
        }}
      >
        {t('cloneToSystemWorkspace')}
      </MenuItem>
      {newType === 'system' && ready && <NewWorkspaceTitle onSave={onSave} onCancel={onCancel} />}
    </>
  );
};
